import Status from 'clarks/components/ivu-table/status'

let forms = {
   editTable: {
      icon: 'fa fa-university',
      title: 'Edit Table',
      subtitle: 'Update Table Details',
      forms: [
         { type: "checkbox", class: "col-12 custom-check", validation: "required", model: "is_accessible", label: "Is Accessible", },
         { type: "checkbox", class: "col-12 custom-check", validation: "required", model: "is_db_configured", label: "Is Db Configured", },
         { type: "text", form_type: "text", class: "col-12 col-md-6", validation: "required|min:3|max:100", model: "alias", label: "Alias", },
         { type: "select", class: "col-12 col-md-6", filterable: true, clearable: true, options: [], validation: "required", model: "unique_field", label: "Unique Field",},
         { type: 'textarea', class: 'col-12', model: 'description', rows: '3', validation: 'min:10|max:500', label: 'Description'},
      ]
   },
   filter_tables: {
      icon: 'fa fa-university',
      title: 'Edit Table',
      subtitle: 'Update Table Details',
      forms: [
         { type: "select", class: "col-md-8 col-lg-5 col-xl-3", filterable: true, clearable: true, options: [], validation: "required", model: "schema", label: "Schema", hide_label: true, placeholder: 'Schema'},
         { type: 'button', btnClass: 'btn-long btn-primary', class: 'col-md-3 col-xl-2', model: 'submit', label: '<i class="fa fa-filter"></i> Filter'},
      ]
   },
}

let tables = {
   table: {
      props: {
         icon: 'fa fa-table',
         title: 'Tables',
         border: true,
         'max-height': 600,
         'show-summary': false,
         search_fields: ['alias', 'name', ],
         columns: [
            { type: 'selection', width: 60, align: 'center' },
            { type: 'index', width: 100, align: 'center' },
            { title: "Name", key: "name", min_width: 200},
            { title: "Alias", key: "alias", },
            { 
               title: "Is Acccessible", 
               slot: "accessibility", 
               align: 'center',
               filters: [{
                     label: "Accessible",
                     value: true
                  },
                  {
                     label: "Not Accessible",
                     value: false
                  }
               ],
               filterMultiple: false,
               filterMethod(value, row) {
                  if(value){
                     return row.is_accessible === true
                  }
                  return row.is_accessible === false
               }
            },
            { title: "Unique Field", slot: "unique_field", },
            { title: "Last Data Pull", slot: "data_pull", },
            {
               title: "Status",
               key: "status",
               align: 'center',
               width: 180,
               render: (h, params) => {
                  return h(Status, {
                     props: {
                        status: params.row.status
                     }
                  });
               },
               filters: [{
                     label: "Created",
                     value: 1
                  },
                  {
                     label: "Updated",
                     value: 2
                  },
                  {
                     label: "Pending Create Verification",
                     value: 3
                  },
                  {
                     label: "Pending Update Verification",
                     value: 4
                  },
                  {
                     label: "Pending Delete Verification",
                     value: 5
                  }
               ],
               filterMultiple: true,
               filterMethod(value, row) {
                  switch (value) {
                     case 1:
                        return row.status === 'created';
                     case 2:
                        return row.status === 'updated';
                     case 3:
                        return row.status === 'create_pending';
                     case 4:
                        return row.status === 'update_pending';
                     case 5:
                        return row.status === 'delete_pending';
                  }
               }
            },
         ],
         actions: [
            { type: 'menu', title: 'View', event: 'view', allow_multiple: false },
            { type: 'menu', title: 'View Fields', event: 'table:view_fields', icon:'fa-align-right', allow_multiple: false },
            { type: 'menu', title: 'Fetch Data', event: 'table:fetch_data', icon: 'fa-database', allow_multiple: false },
            { type: 'menu', title: 'Edit', event: 'table:edit', icon: 'fa-edit', allow_multiple: false },
         ]
      },
   },
}

export default {
   forms: utils.generateAllFormData(forms),
   tables
}